<script setup lang="ts"></script>

<template>
  <span aria-hidden="true" class="text-error ml-0.5">*</span>
  <span class="sr-only">(required)</span>
</template>

<style scoped></style>
